module.exports = __webpack_public_path__ + "013043c60f1fb7a4c59c9a6a8c221846.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/head/Lankenau.jpg
// module id = 887
// module chunks = 0